'use client';
import { jsx } from 'react/jsx-runtime';
import t from 'prop-types';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { RenderComp } from '../core/render-comp.component.js';

let n = {
    skin: t.oneOf([
        'standard',
        'product',
        'circular'
    ]),
    layout: t.oneOf([
        'vertical',
        'horizontal'
    ]),
    imageWidth: t.oneOf([
        'standard',
        'full-bleed'
    ])
}, s = Object.keys(n);
const StandardTile = renderWithRef('StandardTile', n, (e, t)=>{
    useComponentStylesLoaded('StandardTile', SWAN_STYLE_KEY_MAP.standardTile);
    let { skin: n = 'standard', layout: l = 'vertical', imageWidth: i = 'standard' } = e, c = new Set([
        'swan-standard-tile'
    ]);
    return 'standard' !== n && c.add(`swan-standard-tile-skin-${n}`), 'horizontal' === l && c.add('swan-standard-tile-horizontal'), 'full-bleed' === i && 'product' === n && c.add('swan-standard-tile-full-bleed'), jsx(RenderComp, {
        root: "div",
        forwardedRef: t,
        classNames: c,
        props: e,
        propKeysToRemove: s,
        children: e.children
    });
});

export { StandardTile };
